"use strict";

export default {
  setParm(key, value) {
    setTempPar(key, value);
  },
  getParm(key) {
    return getTempPar(key);
  },
  deleteParm(key) {
    return deleteTempPar(key);
  },
  strToSpecial(str) {
    return ConvertNormonStringToSpecial(str);
  },
  // toString(str) {
  //   return ConvertSpecialCharToString(str);
  // },
  setTempParm(key, value) {
    setShortPar(key, value);
  },
  getTempParm(key) {
    return getShortPar(key);
  },
  deleteTempParm(key) {
    return deleteShortPar(key);
  }
};

export function GetShort(key){
  return getShortPar(key);
}

function setTempPar(key, parm) {
  // console.log(parm);
  if (typeof Storage !== "undefined") {
    localStorage.setItem(key, ConvertSpecialCharToString(parm));
  } else {
    setCookie(key, parm);
  }
}

function setShortPar(key, parm) {
  if (typeof Storage !== "undefined") {
    // 是的! 支持 localStorage  sessionStorage 对象!
    sessionStorage.setItem(key, ConvertSpecialCharToString(parm));
  } else {
    setCookie(key, parm);
  }
}

// 还原转换后的特殊字符串
export function BackSpecial(str) {
	return ConvertNormonStringToSpecial(str);
}
// 转换特殊字符串
export function ChangeSpecial(str) {
	return ConvertSpecialCharToString(str);
}

export function GetRandom() {
  var chars = [
    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G",
    "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X",
    "Y", "Z"
  ];
  var maxLength = 4;
  var randomAccount = '';
  for (var i = 0; i < maxLength; i++) {
    var id = Math.ceil(Math.random() * 35);
    randomAccount += chars[id];
  }
  return randomAccount;
}

function getTempPar(parm) {
  var res;
  if (typeof Storage !== "undefined") {
    res = localStorage.getItem(parm);
  } else {
    res = getCookie(parm);
  }
  return ConvertNormonStringToSpecial(res);
}

function getShortPar(parm) {
  var res;
  if (typeof Storage !== "undefined") {
    res = sessionStorage.getItem(parm);
    // console.log(String(res)+' '+parm);
    if(typeof res === "undefined" || String(res)=='null' || res==''){
      res=localStorage.getItem(parm);
      // console.log('ok2=='+String(res)+' '+parm);
    }
  } else {
    res = getCookie(parm);
  }
  return ConvertNormonStringToSpecial(res);
}

function deleteTempPar(parm) {
  if (typeof Storage !== "undefined") {
    localStorage.removeItem(parm);
  } else {
    res = DelCookie(parm);
  }
}

function deleteShortPar(parm) {
  if (typeof Storage !== "undefined") {
		sessionStorage.removeItem(parm);
  } else {
    res = DelCookie(parm);
  }
}

function setCookie(cname, cvalue) {
  var d = new Date();
  //d.setTime(d.getTime()+(exdays*24*60*60*1000));
  d.setTime(d.getTime() + 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


// 删除特殊字符串
export function DeleteSpecialWord(str) {
	str = String(str);
	// console.log(str);
	// str = str.replace(/\#/g, '%23');
	// str = str.replace(/\%/g, '%25');
	// str = str.replace(/\&/g, '%26');
	// str = str.replace(/\+/g, '%2B');
	// str = str.replace(/\//g, '%2F');
	// str = str.replace(/\=/g, '%3D');
	// str = str.replace(/\?/g, '%3F');
	// // str = str.replace(/\./g, '%2E');
	// str = str.replace(/\:/g, '%3A');
	// str = str.replace(/\"/g, '%22');
	// // str = str.replace(/ /g, '%20');
	// //" - %22
	// str = str.replace(' ', '%20');

  str = str.replace(/\#/g, '');
  str = str.replace(/\%/g, '');
  str = str.replace(/\&/g, '');
  str = str.replace(/\+/g, '');
  str = str.replace(/\//g, '');
  str = str.replace(/\=/g, '');
  str = str.replace(/\?/g, '');
  // str = str.replace(/\./g, '%2E');
  str = str.replace(/\:/g, '');
  str = str.replace(/\"/g, '');
  // str = str.replace(/ /g, '%20');
  //" - %22
  str = str.replace(' ', '');

  // str = str.replace(/\n|\r|(\r\n)|(\u0085)|(\u2028)|(\u2029)/g, '<br>');
  // add 2019-06-14 去掉,影响查询语句
  str = str.replace('{', '');
  str = str.replace('}', '');
  str = str.replace('(', '');
  str = str.replace(')', '');
  // console.log(str);
	return str;
}






function checkCookie() {
  var user = getCookie("username");
  if (user != "") {
    alert("欢迎 " + user + " 再次访问");
  } else {
    user = prompt("请输入你的名字:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 30);
    }
  }
}
function DelCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() + -1 * 24 * 60 * 60 * 1000);
  var cval = GetCookieValue(name);
  document.cookie = name + "=" + cval + "; expires=" + exp.toGMTString();
}

function ConvertNormonStringToSpecial(str) {
  str = String(str);

  str = str.replace(/%20/g, " ");
  str = str.replace(/%22/g, '"');
  str = str.replace(/%23/g, "#");
  str = str.replace(/%24/g, "\\");
  str = str.replace(/%25/g, "%");
  str = str.replace(/%26/g, "&");
  str = str.replace(/%2B/g, "+");
  str = str.replace(/%2F/g, "/");
  str = str.replace(/%3D/g, "=");
  str = str.replace(/%3F/g, "?");
  str = str.replace(/%2E/g, ".");
  str = str.replace(/%3A/g, ":");
  return str;
}

function ConvertSpecialCharToString(str) {
  str = String(str);
  // console.log(str);
  str = str.replace(' ', "%20");
  str = str.replace(/\"/g, "%22");
  str = str.replace(/\#/g, "%23");
  str = str.replace(/\\/g, "%24");
  str = str.replace(/\%/g, "%25");
  str = str.replace(/\&/g, "%26");
  str = str.replace(/\+/g, "%2B");
  str = str.replace(/\//g, "%2F");
  str = str.replace(/\=/g, "%3D");
  str = str.replace(/\?/g, "%3F");
  str = str.replace(/\./g, "%2E");
  str = str.replace(/\:/g, "%3A");

  //" - %22
  return str;
}
